import manager from 'app/module46/component-manager.js';

manager.register('upload-image', (component, elements, attributes, properties) => {

	let label = component;

	const {
		id,				// Id de l'entré
		name,			// Nom de l'entré
		action,			// URL a appelé
		accept,			// Détermine les types mimes acceptés
		imageSelector,	// Détermine le sélecteur de l'image
		loaderSelector, // Détermine le sélecteur de chargement
	} = attributes;

	const image = document.querySelector(imageSelector ?? '#picture');
	const loader = document.querySelector(loaderSelector ?? '#loader');

	if(component.tagName != 'LABEL') {

		label = document.createElement('label');

		label.style.position = 'absolute';
		label.style.top = '0px';
		label.style.right = '0px';
		label.style.bottom = '0px';
		label.style.left = '0px';
		label.style.cursor = 'pointer';

		component.style.position = 'relative';

		component.append(label);
	}

	// Crée le contrôleur pour la téléversement de fichier
	const input = document.createElement('input');

	input.id = id;
	input.name = name;
	input.type = 'file';

	input.style.width = '0px';
	input.style.height = '0px';
	input.style.minHeight = '0px';
	input.style.padding = '0px'
	input.style.border = 'none';
	input.style.overflow = 'hidden';

	input.setAttribute('accept', accept ?? 'image/png, image/jpeg');

	// L'image sera sauvegardé automatiquement via un appel ajax

	input.addEventListener('change', () => {

		const file = input.files[0];

		if(file.name && action) {

			const data = new FormData();

			data.append('image', file, file.name);
			data.append('width', image.width);
			data.append('height', image.height);

			$(loader).show();

			manager.api(action, data, (response) => {
				if(image) {
					$(image).hide()
							.prop('src', response.picture)
							.fadeIn();
				}
				$(loader).hide();
			}, () => {
				$(loader).hide();
			});

		} else {

			if(image) {

				URL.revokeObjectURL(image.src);

				$(image).hide()
						.prop('src', URL.createObjectURL(file))
						.fadeIn();
			}
		}

	});

	label.append(input);
});